import successHandler from "../../handlers/successHandler";
import errorHandler from "../../handlers/errorHandler";
import { businessVerificationLevelService } from "../../services/businessVerifiationLevel.service";
import actionType from "./businessVerificationLevelTypes";

export const editBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationLevelService.editBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const storeBusinessVerificationLevel = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["LOADING"], payLoad: true });
    const response =
      await businessVerificationLevelService.storeBusinessVerificationLevel(payLoad);
    dispatch({ type: actionType["LOADING"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: actionType["LOADING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const filterBusinessVerificationLevel = (payLoad, page) => async (dispatch) => {
  try {
    dispatch({ type: actionType["FILTERING"], payLoad: true });
    const response = await businessVerificationLevelService.filterBusinessVerificationLevel(
      payLoad,
      page
    );
    dispatch({ type: actionType["FILTERING"], payLoad: false });
    dispatch({
      type: actionType["FILTER_VERIFICATION_LEVEL"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({ type: actionType["FILTERING"], payLoad: false });
  }
};

export const searchBusinessVerificationLevel = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["SEARCHING"], payLoad: true });
    const response =
      await businessVerificationLevelService.searchBusinessVerificationLevel({
        ...payLoad,
      });
    dispatch({ type: actionType["SEARCHING"], payLoad: false });
    dispatch({
      type: actionType["SEARCH_VERIFICATION"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({ type: actionType["SEARCHING"], payLoad: false });
  }
};

export const showABusinessVerification = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["LOADING"], payLoad: true });
    const response = await businessVerificationLevelService.showABusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["LOADING"], payLoad: false });
    dispatch({
      type: actionType["SHOW_A_VERIFICATION"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({ type: actionType["LOADING"], payLoad: false });
    errorHandler(error, true);
    throw new Error("");
  }
};

export const verifyBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationLevelService.verifyBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};

export const rejectBusinessVerificationAction = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: actionType["UPDATING"], payLoad: true });
    const response = await businessVerificationLevelService.rejectBusinessVerification(
      payLoad
    );
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    successHandler(response, true);
  } catch (error) {
    dispatch({ type: actionType["UPDATING"], payLoad: false });
    errorHandler(error, true);
  }
};
